
import { BriefcaseBusiness, FileImage, Handshake, PartyPopper, PhoneCall, TicketPercent } from 'lucide-react'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const HomeGrid = () => {
    useEffect(() => {
        
    }, [])
    return (
        <div className='container max-w-screen-xl'>

            <div className="py-6"><div className=" mx-auto px-4"><div className="text-center"><h6 className="section-title py-2 "  data-aos-delay="100" >Discover Family Fun Arizona</h6></div></div></div>
            <div className="home-grid-wrapper py-6 ">
                <div className="home-grid grid grid-cols-3 gap-4">
                    <Link to="/event-calender" className="home-grid-child card"  data-aos-delay="250">
                        <div className="card-inner">
                            <div className="card-front">
                                <img src="./assets/home-grid/Family-Fun-AZ-Festivals.jpg" alt="Family Festivals" class="w-full h-auto" />
                            </div>
                            <div className="card-content">
                                <span className='home-card-icon'>
                                    <PartyPopper />
                                </span>
                                <p>Family Festivals</p>

                            </div>
                        </div>
                    </Link>


                    <Link to="/explore" className="home-grid-child card"  data-aos-delay="350">
                        <div className="card-inner">
                            <div className="card-front">

                                <img src="./assets/home-grid/Family_Fun_Club.jpg" alt="Family Festivals" className="w-full h-auto" />
                            </div>
                            <div className="card-content">

                                <span className='home-card-icon'>

                                    <TicketPercent />
                                </span>
                                <p>Deals and Discounts </p>

                            </div>
                        </div>
                    </Link>

                    <Link to="/business-list-directory" className="home-grid-child card"  data-aos-delay="450" >
                        <div className="card-inner">
                            <div className="card-front">

                                <img src="./assets/home-grid/business_directory.png" alt="Family Festivals" className="w-full h-auto" />
                            </div>
                            <div className="card-content">
                                <span className='home-card-icon'>

                                    <BriefcaseBusiness />
                                </span>
                                <p>Business Directory</p>
                            </div>
                        </div>
                    </Link>


                    <Link to='/gallery' className="home-grid-child card"  data-aos-delay="550" >
                        <div className="card-inner">
                            <div className="card-front">
                                <img src="./assets/home-grid/Photo_Gallery.jpg" alt="Family Festivals" className="w-full h-auto" />
                            </div>
                            <div className="card-content">

                                <span className='home-card-icon'>

                                    <FileImage />
                                </span>
                                <p>Photo Gallery </p>

                            </div>
                        </div>
                    </Link>


                    <Link to="/vendor/registration" className="home-grid-child card"  data-aos-delay="750">
                        <div className="card-inner">
                            <div className="card-front">
                                <img src="./assets/home-grid/Become_a_Vendor.jpg" alt="Family Festivals" className="w-full h-auto" />
                            </div>
                            <div className="card-content">

                                <span className='home-card-icon'>

                                    <Handshake />
                                </span>
                                <p>Become a Vendor/Sponsor</p>

                            </div>
                        </div>
                    </Link>


                    <Link to="/contact-us" className="home-grid-child card"  data-aos-delay="950">
                        <div className="card-inner">
                            <div className="card-front">
                                <img src="./assets/home-grid/contact-us.jpg" alt="Family Festivals" className="w-full h-auto" />
                            </div>
                            <div className="card-content">
                                <span className='home-card-icon'>

                                    <PhoneCall />
                                </span>
                                <p>Contact Us</p>
                            </div>
                        </div>
                    </Link>

                </div>
            </div>
        </div>
    )
}

export default HomeGrid